/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The chart labels, number formats and exported layout meet the recipient’s needs.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表标签、数字格式及导出布局满足接收者需求。`)
};

/**
* | output |
* | --- |
* | "The chart labels, number formats and exported layout meet the recipient’s needs." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_5_Table_Rows_1_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_5_table_rows_1_1 as "gc.search_guides.gridcraft_vs_excel.sections.5.table.rows.1.1" }